export default __webpack_public_path__ + "media/zurb/img/services/services/ecommerce-site-img-92f3a25d6da0445323ff3f80510173d4.png";